import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2, AlertCircle, Info, X } from "lucide-react";
import { useToastStore } from "@/app/store/ui.store";
import { cn } from "@/lib/utils/cn";

const config = {
  success: { icon: CheckCircle2, className: "border-success/30 bg-success-muted text-success" },
  danger: { icon: AlertCircle, className: "border-danger/30 bg-danger-muted text-danger" },
  info: { icon: Info, className: "border-info/30 bg-info-muted text-info" },
};

export function Toaster() {
  const { toasts, dismiss } = useToastStore();

  return (
    <div
      className="pointer-events-none fixed bottom-0 right-0 z-[60] flex w-full flex-col gap-2 p-4 sm:max-w-sm"
      // Announced politely: a save confirmation should not interrupt whatever
      // the user is typing.
      role="status"
      aria-live="polite"
    >
      <AnimatePresence initial={false}>
        {toasts.map((t) => {
          const { icon: Icon, className } = config[t.variant] || config.info;
          return (
            <motion.div
              key={t.id}
              layout
              initial={{ opacity: 0, y: 24, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, x: 80, scale: 0.9, transition: { duration: 0.2 } }}
              transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
              className={cn(
                "glass-panel pointer-events-auto flex items-start gap-3 rounded-xl border p-3 text-popover-foreground shadow-premium",
                className
              )}
            >
              <Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
              <div className="flex-1 space-y-0.5">
                <p className="text-[14px] font-medium text-foreground">{t.title}</p>
                {t.description && (
                  <p className="whitespace-pre-line text-[14px] text-muted-foreground">{t.description}</p>
                )}
              </div>
              <button
                type="button"
                onClick={() => dismiss(t.id)}
                className="rounded p-0.5 text-muted-foreground transition-colors hover:text-foreground"
                aria-label="Dismiss"
              >
                <X className="h-3.5 w-3.5" />
              </button>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
